import $axios from '@/axios-silent'

export default class NewPasswordService {
    baseUrl = '/api/v1/auth'

    forgotPassword(params) {
        return $axios.post(this.baseUrl + '/forgot-password', params)
    }

    verifyResetCode(params) {
        return $axios.post(this.baseUrl + '/verify-reset-code', params)
    }

    resetPassword(params) {
        return $axios.post(this.baseUrl + '/reset-password', params)
    }
}

export const NewPasswordServiceInstance = new NewPasswordService()